import { ChangeDetectorRef, Injectable } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { DataConnectorType, DataConnector, FileDataConnector } from 'src/app/domainObjects/dataConnector';
import { DataSourceType } from 'src/app/domainObjects/dataSourceType';
import { IngestConfigViewModel } from 'src/app/views/import-data/import-data.component';
import { FileBrowserDialogComponent } from 'src/app/views/file-browser-dialog/file-browser-dialog.component';
import { DataConnectorViewModel } from 'src/app/viewModels/dataConnectorViewModel';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { ConfigService } from 'src/app/services/config/config.service';
import { BaseComponent } from 'src/app/base/base.component';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedService } from 'src/app/services/shared.service';
import { UserDataService } from 'src/app/services/user-data-service';
// import { IngestParametersSetting, IngestParametersSettings } from 'src/app/domainObjects/masterConfig';
import { FolderBrowserDialogComponent } from 'src/app/views/folder-browser-dialog/folder-browser-dialog.component';
import { DatePipe } from '@angular/common';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { SortBuilderComponent } from 'src/app/views/transform/sort-builder/sort-builder.component';
import { DataTransformerConfig, IngestTransformerConfig } from 'src/app/domainObjects/dataTransformConfig';
import { DeduplicateRows, WhichRowKeep, WhichRowKeepUtil } from 'src/app/domainObjects/ingestTransforms';

@Component({
    selector: 'app-duplicate-data-connector',
    templateUrl: './duplicate-data-connector.component.html',
    styleUrls: ['./duplicate-data-connector.component.css'],
    standalone: false
})

export class DuplicateDataConnectorComponent extends BaseComponent implements OnInit {
  @Input() dataSourceType: DataSourceType;
  @Input() dataTransformConfigViewModel: DataTransformConfigViewModel;
  WhichRowKeepUtil = WhichRowKeepUtil;
  WhichRowKeep = WhichRowKeep;
  WhichRowKeepTypes = [
    WhichRowKeep.keepfirst,
    WhichRowKeep.keeplast,
    WhichRowKeep.removeboth,
    
  ];

 viewModel: DeduplicateRows;

  constructor(
    matDialog: MatDialog,
    errorLogger: ErrorReportingService,private userData: UserDataService) {
      super(errorLogger, matDialog);
    }

  ngOnInit(): void {
   this.viewModel =this.dataTransformConfigViewModel.DeduplicateRows;
   if (this.viewModel.farmType==0) {
      var farmtypeid=this.userData.getSelectedNodeDetails().farmtypeid;
      this.viewModel = new DeduplicateRows(farmtypeid, false,0);
      this.dataTransformConfigViewModel.DeduplicateRows=this.viewModel;
    }
  }

  ngOnChanges(changes: any) {
    this.viewModel =this.dataTransformConfigViewModel.DeduplicateRows;
  }
}
